//The data of the message that will be sent for every new point
export default class PointMessage {
  private type : string = 'child';
  private parent : string;
  private x : number;
  private y : number;

  constructor(x : number, y : number, curLineId : string) {
    this.x = x;
    this.y = y;
    this.parent = curLineId;
  }
}